import React from "react";

// Simple bar chart for one financial row across periods.
export default function BarChart({ labels, values, format }) {
  const W = 900;
  const H = 200;
  const pad = { t: 22, b: 26, l: 10, r: 10 };
  const nums = values.map((v) => (v === null || Number.isNaN(v) ? 0 : v));
  const max = Math.max(...nums, 0);
  const min = Math.min(...nums, 0);
  const span = max - min || 1;
  const bw = (W - pad.l - pad.r) / values.length;
  const y = (v) => pad.t + ((max - v) / span) * (H - pad.t - pad.b);
  const zero = y(0);

  return (
    <svg viewBox={`0 0 ${W} ${H}`} className="bar-chart" role="img" aria-label="Bar chart">
      <line x1={pad.l} x2={W - pad.r} y1={zero} y2={zero} className="pc-grid" />
      {nums.map((v, i) => {
        const x = pad.l + i * bw + bw * 0.18;
        const top = Math.min(y(v), zero);
        const h = Math.max(1, Math.abs(y(v) - zero));
        return (
          <g key={labels[i]}>
            <rect x={x} y={top} width={bw * 0.64} height={h} rx="2" className={v < 0 ? "bar-neg" : "bar-pos"} />
            {values.length <= 14 && (
              <text x={x + bw * 0.32} y={v < 0 ? top + h + 12 : top - 5} textAnchor="middle" className="bar-val">
                {format(values[i])}
              </text>
            )}
            <text x={x + bw * 0.32} y={H - 8} textAnchor="middle" className="pc-axis">
              {labels[i]}
            </text>
          </g>
        );
      })}
    </svg>
  );
}
